/* eslint no-restricted-syntax: 0 */
/* eslint no-await-in-loop: 0 */
/* eslint no-else-return: 0 */
/* eslint no-unreachable: 0 */
/* eslint no-loop-func: 0 */
import * as tfcore from '@tensorflow/tfjs-core';
import * as tf from '@tensorflow/tfjs';
import * as mobilenetModule from '@tensorflow-models/mobilenet';
import * as seedrandom from 'seedrandom';
import {
  setBackendAndEnvFlags,
  normalizePlain,
  flatOneHot,
  fisherYates,
  convertToTfDataset,
  convertBase64ToObject,
  convertObjectToBase64,
  fisherYatesWithTarget,
} from '@utils/hooks/machineLearning/util'
import { Camera } from '../camera';
import { STATE, MODEL_TYPES } from '../params';


export default class ObjectsHandler {
  modelType = MODEL_TYPES.OBJECTS;

  state = STATE;

  seed = seedrandom('testSuite');

  minSamplesRequired = {
    samples: 5,
    classes: 1,
  };

  trainingParams = {
    denseUnits: 256,
    epochs: 50,
    fineTunningEpochs: -1,
    learningRate: 0.00001,
    batchSize: 256,
  };

  imageAugmentation = [
    'unchanged', // required
    'flipLeftRight',
    // 'rotate45',
    'rotate90',
    // 'rotate135',
    // 'rotate180',
    // 'zoomIn',
  ];

  backgroundManagement = 'averageColor' // unchanged, averageColor, black

  frameCounter = 0;

  samplesRectangleMinSize = 90;

  samplesRectangleMaxSize = 260;

  samplesRectangleVariations = 100;

  samplesDisplacementFactor = 5; // rectangleWidth / displacementFactor

  samplesPreviewTime = 1; // ms. 0 to disable

  rectangleDrawingDebouncer = 0; // Average samples. 0 to disable

  rectangleDrawingPosition = { x0: 0, y0: 0, x1: 0, y1: 0 };

  rectangleDrawingPositionAvg = [];

  rectangleRandomPosition = true;

  classColors = [
    '#60aaff',
    '#60ff63',
    '#fffa60',
    '#fc60ff',
    '#ff8d3b',
    '#3bffff',
    '#a03bff',
    '#3bff93',
  ];

  wrapper = null;

  camera = null;

  rafId = null;

  classifying = false;

  predictionCallback = null;

  model = null;

  truncatedModel = null;

  samples = [];

  sampleClippedImage = null;

  samplesTargets = [];

  trainDataset = null;

  validationDataset = null;

  classNamesToIndex = {};

  maxClasses = 5;

  CANVAS_WIDTH = 360;

  CANVAS_HEIGHT = 270;

  outputShape = [1, 224, 224, 3];

  rectangleSize = 100;

  videoCenterX = 0;

  videoCenterY = 0;

  constructor(wrapper, predictionCallback) {
    this.wrapper = wrapper;
    this.predictionCallback = predictionCallback;
  }

  init = async () => {
    this.initWrapper();
    console.log('Handling model Objects');
    await this.initDefaultValueMap();
    this.camera = await Camera.setupCamera(this.state.camera, this.wrapper);
    this.renderPrediction();
    await this.loadPreTrainedModel();
  }

  initWrapper = () => {
    const div = document.getElementsByClassName(this.wrapper);
    if (div.length > 0) {
      const canvas = div[0].getElementsByTagName('canvas')[0];
      if (canvas) {
        canvas.style.width = 'auto';
        canvas.style.height = '100%';
        canvas.style.marginLeft = '-35%';
        canvas.style.left = '50%';
        canvas.style.top = '0';
      }
    }
  }

  initDefaultValueMap = async () => {
    const newState = { ...STATE };
    // newState.camera = { ...STATE.camera, sizeOption: '224 X 224' };

    this.state = newState;
  }

  loadPreTrainedModel = async () => {
    await tf.ready()
    this.state.model = await mobilenetModule.load({
      version: 2,
      alpha: 1.0,
    });
    const embeddings = this.state.model.infer(tfcore.browser.fromPixels(this.camera.video), true);
    this.outputShape = embeddings.shape;
    // this.outputShape = embeddings.shape[1];
    // console.log('===============model ', embeddings, embeddings.dataSync());
    embeddings.dispose();
  }

  renderPrediction = async () => {
    await this.renderResult();
    this.rafId = requestAnimationFrame(this.renderPrediction);
    return null;
  }

  renderResult = async () => {
    const camera = this.camera;
    if (camera.video.readyState < 2) {
      await new Promise((resolve) => {
        camera.video.onloadeddata = () => {
          resolve(true);
        };
      });
    }

    if (this.classifying) {
      // this.frameCounter += 1;
      // if (this.frameCounter % 2 === 0) {
      //   this.frameCounter = 0;
      //   camera.drawCtx();
      //   const prediction = await this.classify();
      camera.drawCtx();
      const prediction = await this.classify();
      if (prediction?.data && prediction?.confidence) {
        if (this.rectangleDrawingDebouncer > 0) {
          if (this.rectangleDrawingPositionAvg.length > this.rectangleDrawingDebouncer) {
            this.rectangleDrawingPosition = {
              x0: this.rectangleDrawingPositionAvg.reduce((acc, val) => acc + val[0], 0) / this.rectangleDrawingPositionAvg.length,
              y0: this.rectangleDrawingPositionAvg.reduce((acc, val) => acc + val[1], 0) / this.rectangleDrawingPositionAvg.length,
              x1: this.rectangleDrawingPositionAvg.reduce((acc, val) => acc + val[2], 0) / this.rectangleDrawingPositionAvg.length,
              y1: this.rectangleDrawingPositionAvg.reduce((acc, val) => acc + val[3], 0) / this.rectangleDrawingPositionAvg.length,
            };
            this.rectangleDrawingPositionAvg = [];
          } else {
            this.rectangleDrawingPositionAvg.push([
              prediction.data[0],
              prediction.data[1],
              prediction.data[2],
              prediction.data[3],
            ]);
          }
        } else {
          this.rectangleDrawingPosition = {
            x0: prediction.data[0],
            y0: prediction.data[1],
            x1: prediction.data[2],
            y1: prediction.data[3],
          };
        }

        camera.drawRectangle(
          this.rectangleDrawingPosition.x0,
          this.rectangleDrawingPosition.y0,
          this.rectangleDrawingPosition.x1,
          this.rectangleDrawingPosition.y1,
          prediction.className,
          this.classColors[this.classNamesToIndex[prediction.className]],
          '4',
          false,
        );
        // }
      }
    } else {
      camera.drawCtx();
      if (!this.camera.preview) {
        const size = this.calculateReactangleOnCurrentFrame();
        if (size) {
          camera.drawRectangle(size.x0, size.y0, size.x1, size.y1);
        }
      }
    }
  }

  mapValue = (value, inMin, inMax, outMin, outMax) => {
    return ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
  }

  classifyScan = () => {
    if (this.model && this.predictionCallback) {
      let results = {};
      let resultsData = {
        confidence: 0,
      };

      const confidenceThreshold = 0.80;
      const imageTensor = tfcore.browser.fromPixels(this.camera.video);

      // black background
      const blackRectangle = tf.zerosLike(imageTensor);
      // average color background
      // const averagePixelValueTensor = imageTensor.cast('float32').mean([0, 1]);
      // const averagePixelValueData = await averagePixelValueTensor.data();
      // averagePixelValueTensor.dispose();
      // blackRectangle = tf.tensor1d(averagePixelValueData).expandDims(0).expandDims(0).tile([this.CANVAS_HEIGHT, this.CANVAS_WIDTH, 1]);

      let rotatedRectangle = this.calculateReactangleOnCurrentFrame();
      let width = rotatedRectangle.x1 - rotatedRectangle.x0;
      let height = rotatedRectangle.y1 - rotatedRectangle.y0;
      while (width > this.samplesRectangleMinSize && height > this.samplesRectangleMinSize) {
        let offsetX = 0;
        let offsetY = 0;
        while (offsetY + height < this.CANVAS_HEIGHT) {
          while (offsetX + width < this.CANVAS_WIDTH) {
            // const results = {};
            // let resultsData = null;

            const logits = tf.tidy(() => {
              const videoTensor = imageTensor.slice([offsetY, offsetX, 0], [height, width, 3]);

              const displacementBottomPad = this.CANVAS_HEIGHT - offsetY - height;
              const displacementRightPadPad = this.CANVAS_WIDTH - offsetX - width;
              const rectangleImagePadded = videoTensor.pad([[offsetY, displacementBottomPad], [offsetX, displacementRightPadPad], [0, 0]]);
              const combinedImage = blackRectangle.add(rectangleImagePadded);

              // tfcore.browser.draw(tf.squeeze(combinedImage.div(255).clipByValue(0, 1)), this.camera.canvas);
              // this.camera.ctx.translate(this.camera.video.videoWidth, 0);
              // this.camera.ctx.scale(-1, 1);

              const embeddings = this.state.model.infer(combinedImage, true);
              return this.model.predict(embeddings.expandDims(0));
            });

            // console.log('===============classify', classProbabilities);
            const classProbabilities = tf.softmax(logits.slice([0, 0], [-1, this.maxClasses])).dataSync();
            const boundingBox = logits.slice([0, this.maxClasses], [-1, 4]).dataSync();
            for (let i = 0; i < Object.keys(this.classNamesToIndex).length; i += 1) {
              const className = Object.keys(this.classNamesToIndex)[i];
              const confidence = classProbabilities[i];
              if (confidence > confidenceThreshold && resultsData.confidence < confidence) {
                results = {};
                results[className] = confidence;
                resultsData = {
                  data: boundingBox.map((value, index) => {
                    // return parseInt(index % 2 === 0 ? value * this.CANVAS_WIDTH : value * this.CANVAS_HEIGHT, 10);
                    return parseInt(value * this.CANVAS_WIDTH, 10);
                  }),
                  className,
                  confidence,
                };
                console.log('===============classify', resultsData.data, boundingBox, width, className, confidence);
                // this.predictionCallback(results);
                // return resultsData;
              }
            }
            // this.predictionCallback(results);

            logits.dispose();
            offsetX += width / this.samplesDisplacementFactor;
          }
          offsetY += height / this.samplesDisplacementFactor;
          offsetX = 0;
        }
        rotatedRectangle = this.calculateReactangleOnCurrentFrame(this.samplesRectangleMinSize / this.samplesRectangleMaxSize);
        width = rotatedRectangle.x1 - rotatedRectangle.x0;
        height = rotatedRectangle.y1 - rotatedRectangle.y0;
      }
      blackRectangle.dispose();
      imageTensor.dispose();
      // return null;
      this.predictionCallback(results);
      return resultsData;
    }
    return null;
  }

  classify = async () => {
    if (this.model && this.predictionCallback) {
      const results = {};
      let resultsData = null;

      const imageTensor = tfcore.browser.fromPixels(this.camera.video);
      const embeddings = this.state.model.infer(imageTensor, true);
      const logits = this.model.predict(embeddings.expandDims(0));

      const classProbabilities = tf.softmax(logits.slice([0, 0], [-1, this.maxClasses])).dataSync();
      const boundingBox = logits.slice([0, this.maxClasses], [-1, 4]).dataSync();

      const confidenceThreshold = 0.60;
      for (let i = 0; i < Object.keys(this.classNamesToIndex).length; i += 1) {
        const className = Object.keys(this.classNamesToIndex)[i];
        const confidence = classProbabilities[i];
        if (confidence > confidenceThreshold) {
          results[className] = confidence;
          resultsData = {
            data: boundingBox.map((value, index) => {
              // return parseInt(index % 2 === 0 ? value * this.CANVAS_WIDTH : value * this.CANVAS_HEIGHT, 10);
              return parseInt(value * this.CANVAS_WIDTH, 10);
            }),
            className,
            confidence,
          };
          console.log('===============classify', className, boundingBox.map((value, index) => {
            // return parseInt(index % 2 === 0 ? value * this.CANVAS_WIDTH : value * this.CANVAS_HEIGHT, 10);
            return parseInt(value * this.CANVAS_WIDTH, 10);
          }));
        }
      }
      logits.dispose();
      imageTensor.dispose();
      embeddings.dispose();
      this.predictionCallback(results);
      return resultsData;
    }
    return null;
  }

  startMedia = async () => {
    this.camera = await Camera.setupCamera(this.state.camera, this.wrapper);
    this.renderPrediction();
    this.initWrapper();
  }

  stopMedia = () => {
    window.cancelAnimationFrame(this.rafId);
    this.rafId = null;

    if (this.camera != null) {
      this.camera.video.srcObject.getVideoTracks().forEach((track) => track.stop());
      this.camera.clearCtx();
    }

    if (this.predictionCallback && this.classifying) {
      this.predictionCallback({});
    }
  }

  clearAllSamples = () => {
    this.classifying = false;
    this.samples = [];
    this.samplesTargets = [];
    this.classNamesToIndex = {};
    // this.model = null;
  }

  startClassifying = () => {
    this.classifying = true;
  }

  stopClassifying = () => {
    this.classifying = false;
  }

  setTrainingParams = (params) => {
    this.trainingParams = {
      ...this.trainingParams,
      ...params,
    };
  }

  getTrainingParams = () => {
    return this.trainingParams;
  }

  getMinSamplesRequired = () => {
    return this.minSamplesRequired;
  }

  calculateReactangleOnCurrentFrame = (resizeTo = 0) => {
    if (this.camera) {
      if (!this.videoCenterX || !this.videoCenterY) {
        this.videoCenterX = this.camera.video.videoWidth / 2;
        this.videoCenterY = this.camera.video.videoHeight / 2;
        // this.rectangleSize = 100;
        this.rectangleSize = this.samplesRectangleMaxSize;
      }
      if (resizeTo > 0) {
        this.rectangleSize -= parseInt(this.rectangleSize * resizeTo, 10);
      } else {
        this.rectangleSize = this.samplesRectangleMaxSize;
      }
      // if (this.rectangleRandomPosition) {
      //   this.rectangleSize = Math.floor(Math.random() * ((this.camera.video.videoHeight / this.samplesRectangleMaxSize) - this.samplesRectangleMinSize - 1) + this.samplesRectangleMinSize);
      //   const minX = this.rectangleSize / 2;
      //   const minY = this.rectangleSize / 2;
      //   const maxX = this.camera.video.videoWidth - minX;
      //   const maxY = this.camera.video.videoHeight - minY;
      //   this.videoCenterX = Math.floor(Math.random() * (maxX - minX + 1) + minX);
      //   this.videoCenterY = Math.floor(Math.random() * (maxY - minY + 1) + minY);
      //   this.rectangleRandomPosition = false;
      // }
      const centerY = this.videoCenterY;
      const halfSize = this.rectangleSize / 2;
      const x0 = Math.max(this.videoCenterX - halfSize, 1);
      const y0 = Math.max(this.videoCenterY - halfSize, 1);
      const x1 = Math.min(this.videoCenterX + halfSize, this.CANVAS_WIDTH - 1);
      const y1 = Math.min(this.videoCenterY + halfSize, this.CANVAS_HEIGHT - 1);
      return { x0, x1, y0, y1 };
    } else {
      return null;
    }
  }

  randomizeReactangle = (rectangle) => {
    const samplesDisplacementFactor = 5 / this.CANVAS_WIDTH; // pixels
    const displacementX = Math.random(-1, 1) * samplesDisplacementFactor;
    const displacementY = Math.random(-1, 1) * samplesDisplacementFactor;
    const boundingBox = [
      Math.max(0, rectangle[0] + displacementX),
      Math.max(0, rectangle[1] + displacementY),
      Math.min(this.CANVAS_WIDTH / this.CANVAS_WIDTH, rectangle[2] + displacementX),
      Math.min(this.CANVAS_HEIGHT / this.CANVAS_WIDTH, rectangle[3] + displacementY),
    ];
    return boundingBox;
  }

  calculateFeaturesOnCurrentFrameWithOffset = async (imageTensor, offsetX, offsetY, rectangle, className = 0) => {
    if (this.camera) {
      const width = rectangle.x1 - rectangle.x0;
      const height = rectangle.y1 - rectangle.y0;
      const newX1 = width + offsetX;
      const newY1 = height + offsetY;
      const boundingBox = [
        offsetX / this.CANVAS_WIDTH,
        offsetY / this.CANVAS_WIDTH,
        // newX1 / this.CANVAS_HEIGHT,
        // newY1 / this.CANVAS_HEIGHT,
        newX1 / this.CANVAS_WIDTH,
        newY1 / this.CANVAS_WIDTH,
      ];

      if (this.samplesPreviewTime) {
        const normalizedTensorFrame = imageTensor.div(255).clipByValue(0, 1);
        tfcore.browser.draw(tf.squeeze(normalizedTensorFrame), this.camera.canvas);
        this.camera.drawRectangle(offsetX, offsetY, newX1, newY1);
        // await new Promise((resolve) => {
        //   tfcore.browser.toPixels(tf.squeeze(normalizedTensorFrame), this.camera.canvas).then(() => {
        //     this.camera.drawRectangle(offsetX, offsetY, newX1, newY1);
        //     setTimeout(() => {
        //       resolve();
        //     }, this.samplesPreviewTime);
        //   });
        // });
        this.camera.ctx.translate(this.camera.video.videoWidth, 0);
        this.camera.ctx.scale(-1, 1);
        normalizedTensorFrame.dispose();
      }

      return tf.tidy(() => {
        const targetTensor = flatOneHot(className, this.maxClasses).concat(boundingBox);
        return { image: imageTensor, target: targetTensor, edgeX: offsetX + (width / this.samplesDisplacementFactor), edgeY: offsetY + (height / this.samplesDisplacementFactor) };
      });
    } else {
      return null;
    }
  }

  blurImage(imageTensor, level) {
    const blurredOutsideRectangle = tf.conv2d(imageTensor.cast('float32'), tf.ones([level, level, imageTensor.shape[2], imageTensor.shape[2]]).div(30), 1, 'same');

    return blurredOutsideRectangle;
  }

  displaceRectangleImage(imageTensor, dx, dy) {
    const translationMatrix = tf.tensor2d([1, 0, dx, 0, 1, dy, 0, 0], [1, 8]);
    const displacedTensor = tf.image.transform(imageTensor.expandDims(0).cast('float32'), translationMatrix, 'nearest', 'nearest', 0);
    return displacedTensor;
  }

  async loadImageAsTensor(imagePath) {
    const img = new Image();
    img.src = imagePath;
    await new Promise((resolve) => {
      img.onload = resolve;
    });
    const imageTensor = tf.browser.fromPixels(img).resizeNearestNeighbor([this.CANVAS_HEIGHT, this.CANVAS_WIDTH]);
    return imageTensor;
  }

  getFrameBackgroundWithHole = async (video, rectangle, offsetX, offsetY) => {
    return tf.tidy(() => {
      const [x0, y0] = [rectangle.x0, rectangle.y0];
      const [x1, y1] = [rectangle.x1, rectangle.y1];
      const width = x1 - x0;
      const height = y1 - y0;
      const averagePixelValueTensor = video.cast('float32').mean([0, 1]);
      // const averagePixelValueData = await averagePixelValueTensor.data();
      const averagePixelValueData = averagePixelValueTensor.dataSync();
      const averagePixelValue = averagePixelValueData[0];
      averagePixelValueTensor.dispose();
      // let sampleClippedImage = null;

      const displacementBottomPad = this.CANVAS_HEIGHT - offsetY - height;
      const displacementRightPadPad = this.CANVAS_WIDTH - offsetX - width;

      const topPad = y0;
      const bottomPad = video.shape[0] - y1;
      const leftPad = x0;
      const rightPad = video.shape[1] - x1;
      const sampleRectangle = video.slice([y0, x0, 0], [height, width, video.shape[2]]);
      const mask = tf.onesLike(sampleRectangle);
      const paddedMask = mask.pad([[offsetY, displacementBottomPad], [offsetX, displacementRightPadPad], [0, 0]]);
      const invertedMask = tf.onesLike(paddedMask).sub(paddedMask);
      const outsideRectangle = video.mul(invertedMask);
      const filledRectangle = tf.zeros([height, width, 3]);
      const paddedFilledRectangle = filledRectangle.pad([[offsetY, displacementBottomPad], [offsetX, displacementRightPadPad], [0, 0]]).clipByValue(0, 155);
      const outsideRectangleFilled = outsideRectangle.add(paddedFilledRectangle);
      // sampleClippedImage = outsideRectangleFilled.clipByValue(0, 255);
      return outsideRectangleFilled.clipByValue(0, 255);

      // sampleRectangle.dispose();
      // mask.dispose();
      // paddedMask.dispose();
      // invertedMask.dispose();
      // outsideRectangle.dispose();
      // filledRectangle.dispose();
      // paddedFilledRectangle.dispose();
      // outsideRectangleFilled.dispose();
      // return sampleClippedImage;
    });
  }

  getFrameBackground = async (video, rectangle, offsetX, offsetY) => {
    let backgroundImage = null;
    switch (this.backgroundManagement) {
      case 'averageColor': {
        const averagePixelValueTensor = video.cast('float32').mean([0, 1]);
        const averagePixelValueData = await averagePixelValueTensor.data();
        averagePixelValueTensor.dispose();
        backgroundImage = tf.tensor1d(averagePixelValueData).expandDims(0).expandDims(0).tile([this.CANVAS_HEIGHT, this.CANVAS_WIDTH, 1]);
      }
        break;
      case 'black':
        backgroundImage = tf.zeros([this.CANVAS_HEIGHT, this.CANVAS_WIDTH, 3]);
        break;
      case 'unchanged':
      default:
        backgroundImage = video.clone();
        break;
    }
    return this.getFrameBackgroundWithHole(backgroundImage, rectangle, offsetX, offsetY);
  }

  async displaceRectangleImageWithFill(imageTensor, video, offsetX, offsetY, rectangle, augmentation = 'unchanged') {
    const [x0, y0] = [rectangle.x0, rectangle.y0];
    const [x1, y1] = [rectangle.x1, rectangle.y1];
    const width = x1 - x0;
    const height = y1 - y0;
    const averagePixelValueTensor = imageTensor.cast('float32').mean([0, 1]);
    const averagePixelValueData = await averagePixelValueTensor.data();
    const averagePixelValue = averagePixelValueData[0];

    if (this.sampleClippedImage) {
      this.sampleClippedImage.dispose();
      this.sampleClippedImage = null;
    }
    this.sampleClippedImage = await this.getFrameBackground(video, rectangle, offsetX, offsetY);

    // extract the rectangle and displaced it
    const displacementBottomPad = this.CANVAS_HEIGHT - offsetY - height;
    const displacementRightPadPad = this.CANVAS_WIDTH - offsetX - width;

    // transform image to get variance
    const rectangleImage = imageTensor.clone();
    let rectangleImageMod = rectangleImage;
    if (augmentation === 'flipLeftRight') {
      const preRectangleImage = tf.image.flipLeftRight(rectangleImage.cast('float32').expandDims(0));
      rectangleImageMod = tf.slice(tf.squeeze(preRectangleImage), [0, 0, 0], [height, width, 3]);
    } else if (augmentation === 'rotate45') {
      const preRectangleImage = tf.image.rotateWithOffset(rectangleImage.cast('float32').expandDims(0), Math.PI / 4, averagePixelValue, 0.5);
      rectangleImageMod = tf.slice(tf.squeeze(preRectangleImage), [0, 0, 0], [height, width, 3]);
    } else if (augmentation === 'rotate90') {
      const preRectangleImage = tf.image.rotateWithOffset(rectangleImage.cast('float32').expandDims(0), Math.PI / 2, averagePixelValue, 0.5);
      rectangleImageMod = tf.slice(tf.squeeze(preRectangleImage), [0, 0, 0], [height, width, 3]);
    } else if (augmentation === 'rotate135') {
      const preRectangleImage = tf.image.rotateWithOffset(rectangleImage.cast('float32').expandDims(0), 3 * (Math.PI / 4), averagePixelValue, 0.5);
      rectangleImageMod = tf.slice(tf.squeeze(preRectangleImage), [0, 0, 0], [height, width, 3]);
    } else if (augmentation === 'rotate180') {
      const preRectangleImage = tf.image.rotateWithOffset(rectangleImage.cast('float32').expandDims(0), Math.PI / 1, averagePixelValue, 0.5);
      rectangleImageMod = tf.slice(tf.squeeze(preRectangleImage), [0, 0, 0], [height, width, 3]);
    } else if (augmentation === 'zoomIn') {
      const preRectangleImage = tf.image.cropAndResize(rectangleImage.cast('float32').expandDims(0), [[0.2, 0.2, 0.8, 0.8]], [0], [rectangleImage.shape[0], rectangleImage.shape[1]]);
      rectangleImageMod = tf.slice(tf.squeeze(preRectangleImage), [0, 0, 0], [height, width, 3]);
    }

    // add the displaced rectangle to the background
    const rectangleImagePadded = rectangleImageMod.pad([[offsetY, displacementBottomPad], [offsetX, displacementRightPadPad], [0, 0]]);
    const combinedImage = this.sampleClippedImage.add(rectangleImagePadded);
    // const combinedImage = this.sampleClippedImage.clone();

    rectangleImageMod.dispose();
    rectangleImage.dispose();
    rectangleImagePadded.dispose();
    averagePixelValueTensor.dispose();

    return combinedImage;
  }

  addSample = async (className) => {
    if (this.camera && className && this.state.model) {
      if (this.classNamesToIndex[className] === undefined) {
        this.classNamesToIndex[className] = Object.keys(this.classNamesToIndex).length || 0;
      }
      const index = this.classNamesToIndex[className];
      if (!this.samples[index]) {
        this.samples[index] = [];
        this.samplesTargets[index] = [];
      }
      this.camera.preview = true;
      const video = tfcore.browser.fromPixels(this.camera.video);

      let sample = null;
      if (this.sampleClippedImage) {
        this.sampleClippedImage.dispose();
        this.sampleClippedImage = null;
      }

      // this.sampleClippedImage = await this.loadImageAsTensor('/images/profiles/maqueta_bsas_semaforo.png');

      let rotatedRectangle = this.calculateReactangleOnCurrentFrame();
      let width = rotatedRectangle.x1 - rotatedRectangle.x0;
      let height = rotatedRectangle.y1 - rotatedRectangle.y0;
      let videoTensor = video.slice([rotatedRectangle.y0, rotatedRectangle.x0, 0], [height, width, 3]);
      // const videoBlured = this.blurImage(video, 5);
      console.log('===============videoTensor', videoTensor.shape, videoTensor.dataSync());
      while (width > this.samplesRectangleMinSize && height > this.samplesRectangleMinSize) {
        let offsetX = 0;
        let offsetY = 0;
        while (offsetY + height < this.CANVAS_HEIGHT) {
          while (offsetX + width < this.CANVAS_WIDTH) {
            for (let i = 0; i < this.imageAugmentation.length; i += 1) {
              const displacedTensor = await this.displaceRectangleImageWithFill(videoTensor, video, offsetX, offsetY, rotatedRectangle, this.imageAugmentation[i]);

              sample = await this.calculateFeaturesOnCurrentFrameWithOffset(displacedTensor, offsetX, offsetY, rotatedRectangle, index);
              const embeddings = this.state.model.infer(sample.image, true);
              const embeddingData = await embeddings.data();
              for (let j = 0; j < this.samplesRectangleVariations * (width / this.samplesRectangleMaxSize); j += 1) {
                const targetVariations = sample.target.slice(0, this.maxClasses).concat(this.randomizeReactangle(sample.target.slice(this.maxClasses)));
                this.samples[index].push(embeddingData);
                this.samplesTargets[index].push(targetVariations);
                displacedTensor.dispose();
                sample.image.dispose();
              }
              embeddings.dispose();
            }
            offsetX = sample.edgeX;
          }
          offsetY = sample.edgeY;
          offsetX = 0;
        }
        rotatedRectangle = this.calculateReactangleOnCurrentFrame(this.samplesRectangleMinSize / this.samplesRectangleMaxSize);
        width = rotatedRectangle.x1 - rotatedRectangle.x0;
        height = rotatedRectangle.y1 - rotatedRectangle.y0;
        // console.log('===============videoTensor', videoTensor.shape, videoTensor.dataSync());
        videoTensor = tf.image.resizeNearestNeighbor(videoTensor.cast('float32').expandDims(0), [height, width]).squeeze();
      }
      this.camera.preview = false;
      this.rectangleRandomPosition = true;
      videoTensor.dispose();
      video.dispose();
      return this.samples[index].length || 0;
    }
    return 0;
  }

  getSamples = () => {
    return {
      modelType: this.modelType,
      samples: this.samples,
      samplesTargets: this.samplesTargets,
    };
  }

  setSamples = (samples, classesArray) => {
    if (samples.modelType === this.modelType) {
      // this.samples = samples.samples;
      // Bug: cut shape of saved sample ([1296]) to [1280]
      this.samples = samples.samples.map((sampleArr) => sampleArr.map((sample) => sample.slice(0, this.outputShape[1])));
      // this.samples = samples.samples.map((sampleArr) => sampleArr.map((sample) => sample.slice(0, this.outputShape)));
      this.samplesTargets = samples.samplesTargets;
      const nSamples = {};
      this.samples.map((sampleArr, classIndex) => {
        if (sampleArr && classesArray[classIndex] !== undefined) {
          const className = classesArray[classIndex][0]
          if (this.classNamesToIndex[className] === undefined) {
            this.classNamesToIndex[className] = classIndex;
          }
          nSamples[className] = sampleArr.length;
        }
        return null
      });
      return Object.keys(nSamples).length > 0 ? nSamples : false;
    } else {
      return false;
    }
  }

  exportSamples = () => {
    const samples = this.getSamples();
    if (samples) {
      const jsonString = JSON.stringify(convertObjectToBase64(samples), null, 2);
      const blob = new Blob([jsonString], { type: 'text/plain' });
      const link = document.createElement('a');
      link.download = `muestras-educabot-${this.modelType}.txt`;
      link.href = window.URL.createObjectURL(blob);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  importSamples = (files = [], classesArray = null) => {
    return new Promise((resolve, reject) => {
      if (files[0].name.endsWith('.txt')) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const samples = convertBase64ToObject(JSON.parse(e.target.result, null, 2));
          if (samples && classesArray.length > 0 && samples.modelType === this.modelType) {
            this.samples = samples.samples.map((sampleArr) => sampleArr.map((sample) => sample.slice(0, this.outputShape[1])));
            this.samplesTargets = samples.samplesTargets;
            const nSamples = {};
            this.samples.map((sampleArr, classIndex) => {
              if (sampleArr && classesArray[classIndex] !== undefined) {
                const className = classesArray[classIndex][0]
                if (this.classNamesToIndex[className] === undefined) {
                  this.classNamesToIndex[className] = classIndex;
                }
                nSamples[className] = sampleArr.length;
              }
              return null
            });
            if (Object.keys(nSamples).length > 0) {
              resolve(nSamples)
            } else {
              reject();
            }
          } else {
            reject();
          }
        };
        reader.readAsText(files[0]);
      } else {
        reject();
      }
    });
  }

  customLossFunction = (yTrue, yPred) => {
    const classIndexLoss = tf.losses.softmaxCrossEntropy(
      yTrue.slice([0, 0], [-1, this.maxClasses]),
      yPred.slice([0, 0], [-1, this.maxClasses]),
    );
    const bboxLoss = tf.losses.huberLoss(
      yTrue.slice([0, this.maxClasses], [-1, 4]),
      yPred.slice([0, this.maxClasses], [-1, 4]),
    );
    return classIndexLoss.add(bboxLoss.mul(10));
  };

  buildNewHead = (inputShape) => {
    const newHead = tf.sequential();
    newHead.add(tf.layers.flatten({ inputShape }));
    newHead.add(tf.layers.batchNormalization());
    newHead.add(tf.layers.dense({
      units: this.trainingParams.denseUnits,
      activation: 'relu',
      kernelRegularizer: tf.regularizers.l2({ l2: 0.9 }),
    }));
    newHead.add(tf.layers.dropout({ rate: 0.9 }));
    // newHead.add(tf.layers.dense({
    //   units: 128,
    //   activation: 'relu',
    // }));
    // newHead.add(tf.layers.dropout({ rate: 0.5 }));

    // newHead.add(tf.layers.dense({
    //   units: 32,
    //   activation: 'relu',
    //   kernelRegularizer: tf.regularizers.l2({ l2: 0.8 }),
    // }));
    // newHead.add(tf.layers.dropout({ rate: 0.7 }));

    // newHead.add(tf.layers.dense({
    //   units: 32,
    //   activation: 'relu',
    // }));
    // newHead.add(tf.layers.dropout({ rate: 0.5 }));

    newHead.add(tf.layers.dense({
      units: this.maxClasses + 4,
      activation: 'linear',
    }));
    return newHead;
  }

  train = async (callbacks) => {
    if (this.model) {
      this.model.dispose();
    }
    this.model = this.buildNewHead(this.outputShape);
    // this.model.summary();

    this.model.setUserDefinedMetadata({ classNames: this.classNamesToIndex });

    if (!(parseInt(this.trainingParams.batchSize, 10) > 0)) {
      throw new Error('Batch size is 0 or NaN. Please choose a non-zero fraction');
    }

    const images = [];
    const weights = [];
    this.samples.map((sampleArr) => {
      weights.push(sampleArr.length);
      sampleArr.map((sample) => {
        images.push([sample]);
        // images.push(tf.tensor(sample));
        return null;
      });
      return null;
    });

    const targets = [];
    this.samplesTargets.map((sampleArr) => {
      return sampleArr.map((sample) => {
        targets.push(tf.tensor(sample));
        return null;
      });
      return null;
    });
    const { shuffled, shuffledTarget } = fisherYatesWithTarget(images, targets);
    const imagesShuffled = shuffled;
    const targetsShuffled = shuffledTarget;
    // console.log('===============train', this.classNamesToIndex, images, targets, imagesShuffled, targetsShuffled);

    const optimizer = tf.train.rmsprop(parseFloat(this.trainingParams.learningRate));
    this.model.compile({
      optimizer,
      loss: this.customLossFunction,
      metrics: ['accuracy', tf.metrics.meanAbsoluteError],
      weights,
    });

    const datasetSize = shuffled.length;
    const validationSplit = 0.15;
    const trainSize = Math.floor(datasetSize * (1 - validationSplit));
    const trainImages = shuffled.slice(0, trainSize);
    const trainTargets = shuffledTarget.slice(0, trainSize);
    const validationImages = shuffled.slice(trainSize);
    const validationTargets = shuffledTarget.slice(trainSize);
    // await this.model.fit(tf.stack(imagesShuffled), tf.stack(targetsShuffled), {
    await this.model.fit(tf.stack(trainImages), tf.stack(trainTargets), {
      validationData: [tf.stack(validationImages), tf.stack(validationTargets)], // Explicit validation data
      epochs: parseInt(this.trainingParams.epochs, 10),
      batchSize: parseInt(this.trainingParams.batchSize, 10),
      // validationSplit: 0.3,
      callbacks,
      shuffle: true,
    });

    optimizer.dispose(); // cleanup
    return this.model;
  }

  save = async (name = 'modelo-educabot-objetos') => {
    // Save to local storage
    const saveResults = await this.model.save(`localstorage://${name}`);
  }

  load = async (name = 'modelo-educabot-objetos') => {
    // Load from local storage
    const loadedModel = await tf.loadLayersModel(`localstorage://${name}`);
  }

  export = async (name = 'modelo-educabot-objetos') => {
    const saveResults = await this.model.save(`downloads://${name}`);
  }

  import = async (json, weights) => {
    this.model = await tf.loadLayersModel(tf.io.browserFiles([json, weights]));
    // this.model = await tf.loadLayersModel(tf.io.browserFiles([json.files[0], weights.files[0]]));
    if (this.model) {
      console.log('===============import', this.model);
      this.classNamesToIndex = this.model.getUserDefinedMetadata().classNames;
      return this.classNamesToIndex;
    } else {
      return false;
    }
  }

  loadModel = async (json, weights) => {
    this.model = await tf.loadLayersModel(`${this.state.importModelApi}/${json}/${weights}/model.json`);
    if (this.model) {
      this.classNamesToIndex = this.model.getUserDefinedMetadata().classNames;
      return this.classNamesToIndex;
    } else {
      return false;
    }
  }
}
